import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Article = styled.div`
	background: white;
	width: 100%;
	border-radius: 10px;

	p {
		padding: 0 20px 10px;
		line-height: 1.7;
		font-size: 14px;
	}
`;

export const Title = styled.span`
	height: 40px;
	flex-shrink: 0;
	color: ${tokens.color_gray_dark};
	background-color: #f5f7fa;
	display: flex;
	align-items: center;
	width: 100%;
	font-size: 14px;
	font-weight: 600;
	padding: 0 20px;
`;
